interface MediumPillProps {
  medium: string;
}

export function MediumPill({ medium }: MediumPillProps) {
  return (
    <span className="inline-flex h-6 shrink-0 items-center rounded-full bg-white/20 px-2 text-xs whitespace-nowrap text-white capitalize">
      {medium}
    </span>
  );
}
